import { InjectionToken } from '@angular/core';
import { TranslocoMessageService } from '@bbraun/shared/util-transloco-message';

export const BAV_REPORTING_ADMINISTRATION_MESSAGE_SERVICE =
  new InjectionToken<TranslocoMessageService>(
    'BAV_REPORTING_ADMINISTRATION_MESSAGE_SERVICE',
  );
